const handleKeyboard = ({
  e,
  data = null,
  tab = () => { },
  enter = () => { },
  arrowUp = () => { },
  arrowDown = () => { },
  arrowRight = () => { },
  arrowLeft = () => { },
  other = () => { }
}) => {
  switch (e.key) {
    case 'Tab':
      tab(e, data);
      break;
    case 'Enter':
      enter(e, data);
      break;
    case 'ArrowDown':
      arrowDown(e, data);
      break;
    case 'ArrowUp':
      arrowUp(e, data);
      break;
    case 'ArrowRight':
      arrowRight(e, data);
      break;
    case 'ArrowLeft':
      arrowLeft(e, data);
      break;
    default:
      other(e, data);
      break;
  }
};

export default handleKeyboard;